<p-card styleClass="app-card">
  <ng-template pTemplate="content">
    <div class="app-card-inner app-card-relative" role="article">

      <span
        class="app-status-badge {{ statusConfig.cssClass }}"
        [pTooltip]="statusConfig.label | translate"
        tooltipPosition="top"
        aria-hidden="true"
      >
        <i class="pi {{ statusConfig.icon }}" aria-hidden="true"></i>
        {{ statusConfig.label | translate }}
      </span>

      <div class="app-card-avatar" aria-hidden="true">
        <img
          src="/assets/img/nube_cc_200x140.png"
          alt=""
        />
      </div>

      <div class="app-card-info">
        <span class="app-card-org">
          <i class="pi pi-desktop" aria-hidden="true"></i>
          {{ app.orgName }}
        </span>
        <span class="app-card-name">{{ app.appName }}</span>
      </div>

      <p-button
        styleClass="app-btn-access"
        icon="pi pi-sign-in"
        [label]="app.appName"
        size="small"
        [raised]="true"
        iconPos="right"
        [disabled]="app.status !== AppStatus.Running"
        [attr.aria-disabled]="app.status !== AppStatus.Running ? 'true' : null"
        [attr.aria-label]="('USER.APP_ACCESS_LABEL' | translate : { appName: app.appName, orgName: app.orgName })"
        [attr.title]="app.status !== AppStatus.Running ? ('USER.APP_DISABLED_TITLE' | translate) : null"
        (onClick)="onSelect()"
      ></p-button>

    </div>
  </ng-template>
</p-card>
